import { FC } from 'react'
import { useParams } from 'react-router-dom'

import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import { RawTag } from '@factorialco/factorial-one-react/dist/experimental'
import { Person } from '@factorialco/factorial-one-react/icons/app'

import { NODE_SIZE } from 'modules/job_catalog/hooks/useJobCatalogTree'
import { JobCatalogNodeData } from 'modules/job_catalog/pages/JobCatalogTreePage/types'

import CollapsibleButton from '../CollapsibleButton'
import Line from '../Line'

interface Props {
  x: number
  y: number
  roleId: string
  roleName: string
  isUncollapsed: boolean
  levels: JobCatalogNodeData[]
  onNodeSelection?: (nodeId: string) => void
  onCollapseChange?: () => void
}

const LevelGroup: FC<Props> = ({
  x,
  y,
  roleId,
  roleName,
  isUncollapsed,
  levels,
  onNodeSelection,
  onCollapseChange,
}) => {
  const { id } = useParams<{ id: string }>()

  const [width, height] = NODE_SIZE

  return (
    <foreignObject x={x} y={y} width={width} height={height * 2} style={{ overflow: 'visible' }}>
      <Box flexDirection="column" alignItems="center" padding="s8">
        <Box padding="s12" justifyContent="center" alignItems="center">
          <Box
            position="relative"
            borderRadius={{ all: 'rel333' }}
            border={
              id === roleId ? { all: { color: 'viridian800', style: 'solid', width: 's4' } } : {}
            }
            padding="s2"
            onClick={() => onNodeSelection?.(roleId)}
          >
            <Avatar size="s64" label={roleName} />
          </Box>
          <Text weight="semibold" size="200" whiteSpace="nowrap" ellipsis>
            {roleName}
          </Text>
          <RawTag text="role" icon={Person} />
        </Box>
        <>
          <Line />
          <CollapsibleButton
            childrenCount={levels.length}
            isUncollapsed={isUncollapsed}
            onCollapseChange={onCollapseChange ?? (() => {})}
          />
        </>
        <Box flexDirection="column" gap="s8" style={{ marginTop: '16px' }} width="full">
          {levels.map((level) => (
            <Box
              key={level.id}
              borderRadius={{ all: 'abs100' }}
              padding="s8"
              paddingX="s12"
              onClick={() => onNodeSelection?.(level.id)}
              style={{ cursor: 'pointer' }}
              border={{
                all: {
                  color: id === level.id ? 'viridian800' : 'grey100',
                  style: 'solid',
                  width: 's2',
                },
              }}
            >
              <Text size="200" ellipsis weight={id === level.id ? 'semibold' : 'normal'}>
                {level.name}
              </Text>
            </Box>
          ))}
        </Box>
      </Box>
    </foreignObject>
  )
}

export default LevelGroup
